<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-60 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
        <div class="d-flex-column justify-start align-start gap-16">
          <LazyCustomSeasonLengthNew
            v-if="showSeasonLength"
            :season-length="getGame?.game_season"
          />
          <NestPackSelector />
        </div>
      </div>
      <div
        class="d-flex-column flex-65 justify-start align-start t-white gap-0"
        style="overflow-x: hidden"
      >
        <PoeLevelingBoost
          v-if="categoryPackSlug === 'path-of-exile-2-power-leveling-boost'"
        />
        <PoeGearBoost
          v-if="categoryPackSlug === 'path-of-exile-2-leveling-gear-boost'"
        />
      </div>

      <div
        class="d-flex-column flex-2 justify-start align-start t-white cart_container"
      >
        <WhyWeCheap />
        <Cart />
      </div>
    </div>

    <div class="d-flex-row justify-end">
      <div
        class="d-flex-column justify-start flex-825 flex-lg-10"
        style="margin-top: 30px"
      >
        <div class="d-flex-column gap-0">
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}
          </p>
          <h2
            class="t-white font-family-1 title-h2 f-w-600"
            style="text-align: center"
          >
            {{ $t("homepage.got_a_question") }}
            <br />
            {{ $t("homepage.we_have")
            }}<span class="t-light-orange">{{ $t("homepage.answers") }}</span
            >!
          </h2>
        </div>

        <div class="d-flex-row align-start lg-row-to-col">
          <div class="d-flex-column">
            <Faq :faqs="[...gameFaqs].splice(0, 4)" variant="pack twocol" />
          </div>
          <div class="d-flex-column">
            <Faq :faqs="[...gameFaqs].splice(4, 6)" variant="pack twocol" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import GamePackBanner from "~/components/banners/GamePackBanner.vue";

import NestPackSelector from "~/components/sections/boosting/NestPackSelector.vue";
import PoeLevelingBoost from "~/components/calculators/path-of-exile/PoeLevelingBoost.vue";
import PoeGearBoost from "~/components/calculators/path-of-exile/PoeGearBoost.vue";
import Cart from "~/components/calculators/checkout/Cart.vue";
import Faq from "../../custom/Faq.vue";
import SeasonLength from "~/components/custom/SeasonLength.vue";
import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";

const { categoryPackSlug, currentGameSlug, currentGamePackSlug } =
  useGameComposable();

const { getLocale } = useFunctions();
const { setGamePack, getGamePack, apiGetGame, getGame, apiGetGameRanks } =
  useGameStore();
const categoryData = ref(null);
const router = useRouter();
const route = router.currentRoute;
const localePath = useLocalePath();

const gameFaqs = computed(() => {
  if (getGame?.faqs) {
    return getGame?.faqs;
  }
  return [];
});

const { data: response, error } = await useApiFetch(
  `/api/get-game-pack/${categoryPackSlug}`,

  {
    fetchKey: `/api/get-game-pack/${categoryPackSlug}`,
    method: "POST",
    body: {
      locale: getLocale(),
      params: ["prices", "pack_options", "pack_extra_options", "faqs"],
    },
  }
);

if (error.value?.data) {
  throw createError({
    statusCode: "404",
    statusMessage: "Not Found",
  });
}

apiGetGame({
  gameSlug: currentGameSlug,
  locale: getLocale(),
});

apiGetGameRanks({
  gameSlug: currentGameSlug,
  locale: getLocale(),
});

if (response.value?.data) {
  setGamePack(response.value?.data);
  categoryData.value = response.value?.data;
  useSeoMeta({
    title: response.value?.data?.meta_title,
    description: response.value?.data?.description,
  });
}
addCanonicalLink(route.value.fullPath);

const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});
</script>

<style lang="scss"></style>
